import { render, staticRenderFns } from "./SmsApplianceRemindRate.vue?vue&type=template&id=0037cd09&scoped=true"
import script from "./SmsApplianceRemindRate.vue?vue&type=script&lang=js"
export * from "./SmsApplianceRemindRate.vue?vue&type=script&lang=js"
import style0 from "./SmsApplianceRemindRate.vue?vue&type=style&index=0&id=0037cd09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037cd09",
  null
  
)

export default component.exports